/**
 * Base URL for the Azure Blob Storage
 */
const BLOB_BASE_URL = "https://kvtsaistorageprod.blob.core.windows.net";

/**
 * Mapping from local public folder codes to Blob Storage folder names
 */
const FOLDER_MAPPINGS = {
  ml: "malayalam",
  or: "oriya",
  kn: "kannada",
  en: "english",
  bn: "bengali",
  te: "telugu",
  mr: "marathi",
  gu: "gujarati",
  ta: "tamil",
  hi: "hindi",
  enAtGlance: "enatglance",
  enKeytakeaway: "enkeytakeaway",
};

export const getBlobUrl = (path) => {
  if (!path) return "";

  let cleanPath = path;

  // Handle full URLs (e.g. http://localhost:3000/en/...)
  if (cleanPath.startsWith('http')) {
    try {
      const url = new URL(cleanPath);
      cleanPath = url.pathname;
    } catch (e) {
      // If invalid URL, continue with original string
    }
  }

  // Remove leading slash for processing if present
  cleanPath = cleanPath.startsWith('/') ? cleanPath.slice(1) : cleanPath;

  // Handle paths that explicitly include 'public'
  if (cleanPath.startsWith('public/')) {
    cleanPath = cleanPath.slice(7);
  }

  const parts = cleanPath.split('/');
  const rootKey = parts[0];

  if (FOLDER_MAPPINGS[rootKey]) {
    const blobFolder = FOLDER_MAPPINGS[rootKey];
    const remainingPath = parts.slice(1).join('/');
    return `${BLOB_BASE_URL}/${blobFolder}/${remainingPath}`;
  }

  // Return original path if no mapping is found (serves from local)
  return path;
};